module.exports = __webpack_public_path__ + "img/muching.36d2908f.png";